import type { AnyAction, Store } from "redux";
import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import type { ThunkDispatch } from "redux-thunk";

import { featureFlagMiddleware } from "./middleware/featureFlagMiddleware";
import { logRocketMiddleware } from "./middleware/logRocketMiddleware";
import { patientAuthMiddleware } from "./middleware/patientAuthMiddleware";
import rootReducer from "./reducers";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

export type RootState = ReturnType<typeof rootReducer>;
// redux-thunk lets action creators dispatch thunks (functions) in addition to
// plain actions — AnyAction alone (the untyped Store default) rejects those.
export type AppDispatch = ThunkDispatch<RootState, undefined, AnyAction>;

const initialState = {};

const middleWare = [thunk, featureFlagMiddleware, logRocketMiddleware, patientAuthMiddleware];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(applyMiddleware(...middleWare)),
) as Store<RootState, AnyAction> & { dispatch: AppDispatch };

export default store;
